module.exports = __webpack_public_path__ + "static/media/SashaDiamondMenuLogo.094ca704.png";